export class TourActionRegistry {
    constructor() {
        this.actions = new Map();
        this.restoreActions = [];
    }
    register(key, action) {
        this.actions.set(key, action);
        return () => {
            if (this.restoreActions.some((item) => item.key === key))
                this.restore();
            if (this.actions.get(key) === action)
                this.actions.delete(key);
        };
    }
    has(key) {
        return this.actions.has(key);
    }
    run(key) {
        const action = this.actions.get(key);
        if (!action)
            return false;
        try {
            const restore = action();
            this.restoreActions.push({ key, restore });
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    runOnce(key) {
        return this.restoreActions.some((item) => item.key === key) || this.run(key);
    }
    restore() {
        for (const { restore } of this.restoreActions.splice(0).reverse()) {
            try {
                restore();
            }
            catch ( /* An unmounted page may no longer be able to restore its local UI state. */_a) { /* An unmounted page may no longer be able to restore its local UI state. */ }
        }
    }
}
